import { createModel } from '@rematch/core';
import type { RootModel } from '@/models';
import { getOneMonthPeriod } from '@/std/datetime';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { RomaneioState } from './types';
import { effects } from './effects';

const initialState: RomaneioState = {
    filterDataEmissao: getOneMonthPeriod(),
    filterNumber: '',
    filterSearch: '',
    filterStatus: 'Previsão',
    get: initReduxFn,
    getNotas: initReduxFn,
    getTotais: initReduxFn,
    getVendas: initReduxFn,
    pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: false,
        showTotal: () => '',
        total: 22,
    },
    post: initReduxFn,
    put: initReduxFn,
    remove: initReduxFn,
    sortParams: {
        fieldName: '',
        orderDirection: 'asc',
        shouldSort: false,
    },
};

export const RomaneioModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<RomaneioState>(),
    state: initialState,
});
